module.exports = __webpack_public_path__ + "img/bayonetta-min.c36b02ee.png";